import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

function getBackgroundColor(color, theme) {
  switch (color) {
    case "secondary":
      return theme.colors.black;
    case "gray":
      return theme.colors.lightGray;
    default:
      return theme.colors.primary;
  }
}

function getFontColor(color, theme) {
  switch (color) {
    case "gray":
      return "gray";
    default:
      return theme.colors.white;
  }
}

const StyledButton = styled.button`
  background: ${({ theme, color }) => getBackgroundColor(color, theme)};
  border: ${({ theme, color }) =>
    `2px solid ${getBackgroundColor(color, theme)}`};
  border-radius: 3px;
  padding: 10px 20px;
  font-weight: bold;
  color: ${({ color, theme }) => getFontColor(color, theme)};
  font-size: 1.2rem;
  cursor: pointer;
  opacity: 0.9;
  transition: all 200ms ease-in-out;

  &:focus {
    outline: none;
  }

  &:hover {
    opacity: 1;
    padding-left: 30px;
    padding-right: 30px;
  }
`;

const Loader = styled.div`
  border: ${({ theme }) => `3px solid ${theme.colors.black}`};
  border-top: 3px solid transparent;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 0.75s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default function Button(props) {
  const { children, type, onClick, color, loading } = props;
  return (
    <StyledButton {...props} type={type} onClick={onClick} color={color}>
      {loading ? <Loader /> : children}
    </StyledButton>
  );
}

Button.defaultProps = {
  children: null,
  type: "button",
  onClick: undefined,
  color: "primary",
  loading: false,
};

Button.propTypes = {
  children: PropTypes.node,
  type: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.oneOf(["primary", "secondary", "gray"]),
  loading: PropTypes.bool,
};
